module.exports = __webpack_public_path__ + "img/grading_draw.53374258.png";